module.exports = __webpack_public_path__ + "img/UI_common_framelabelWF_01_f758dca42.png";